import { FlowValues } from '@betterment/js-runtime';

export interface ControllerProps {
  currentPhoneNumber: string;
  email: string;
  firstName: string;
  lastName: string;
  totalBettermentBalanceCents: number;
  balanceThresholds: BalanceThresholds;
  additionalPremiumFeePercent: string;
  premiumMinBalanceDescriptionHtml: string;
  signupIntent: string;
  flowPath?: CallType;
}

export type BalanceThresholds = {
  conciergeIntroMinimumBalanceCents: number;
  conciergeSpecialistMinimumBalanceCents: number;
  conciergeExpertMinimumBalanceCents: number;
  premiumAdviceMinimumBalanceCents: number;
};

export type AdviceInitiationFlowValues = FlowValues<{
  exitToPath: string;
  returnToPath: string;
  currentInvestments: string;
  selectedAccountTypes: string[];
  interests: string;
  phoneNumber: string;
  activePhoneNumberType: PhoneNumberType;
  intendedTransferAmountCents: number;
  totalBettermentBalanceCents: number;
  flowPath: CallType;
  hasSolo401kIntent: boolean;
  estimatedTransferAmount: string;
}>;

export enum CallType {
  Concierge = 'concierge',
  Exploratory = 'exploratory',
  AdvisorNetworkExploratory = 'advisor_network_exploratory',
  Premium = 'premium',
  Default = '',
}

export enum PhoneNumberType {
  Current = 'currentPhoneNumber',
  New = 'newPhoneNumber',
}

export interface CalendlyCallDataParams {
  eventId: string;
  flowPath: string;
  url: string;
}
